/**
 * Build-time catalog for all SEO service landing pages.
 * Used when the API is slow or unavailable so the home carousel and /services
 * page still render immediately with correct links to /service/:slug.
 */
import { SERVICE_SLUGS, SERVICE_LANDING_CONTENT, getCanonicalPathForContent } from './serviceLandingContent';
import { SERVICE_CARD_FALLBACK_IMAGE } from '../constants/siteBranding';

/** Prefer public SEO URL (e.g. /valet-parking-ahmedabad) when defined on landing content. */
export function getServicePath(slug) {
  if (!slug) return '/services';
  const c = SERVICE_LANDING_CONTENT[slug];
  if (c) return getCanonicalPathForContent(c);
  return `/services/${slug}`;
}

const OTHER_SERVICE_SLUGS = new Set([
  'valet-parking-ahmedabad',
  'driver-service-agent-ahmedabad',
  'deep-cleaning-service-ahmedabad',
  'special-event-cleaning-works-ahmedabad',
  'carpet-cleaning-service-ahmedabad',
  'house-cleaning-ahmedabad'
]);

function categoryForSlug(slug) {
  return OTHER_SERVICE_SLUGS.has(slug) ? 'Other Service' : 'House and Office';
}

/**
 * @returns {Array<{ id: string, title: string, slug: string, category: string, description: string, image_url: string|null }>}
 */
export function getStaticServicesCatalog() {
  return SERVICE_SLUGS.map((slug) => {
    const c = SERVICE_LANDING_CONTENT[slug];
    if (!c) return null;
    return {
      id: slug,
      title: c.name,
      slug: c.slug,
      category: categoryForSlug(slug),
      description: c.metaDescription,
      image_url: SERVICE_CARD_FALLBACK_IMAGE
    };
  }).filter(Boolean);
}

export const STATIC_SERVICES_CATALOG = getStaticServicesCatalog();
